import { forwardRef, MenuItem, RecursivePseudo, StyleProps } from '@chakra-ui/react';
import { PropsWithChildren, ReactElement } from 'react';

import { CheckOutline } from '@bonusly/ds-icon';

import { useDropdownContext } from '../lib/context';

export interface DropdownOptionProps extends StyleProps, RecursivePseudo<any>, PropsWithChildren {
	checkIcon?: ReactElement;
	compareIsSelected?: (selected: any, optionValue: any) => boolean;
	value: any;
}

export const DropdownOption = forwardRef<DropdownOptionProps, 'button'>(
	({ children, checkIcon = <CheckOutline color="text.interactive" size="md" />, compareIsSelected, value: optionValue, ...rest }, ref) => {
		const { onChange, value, valueToString } = useDropdownContext();

		const isSelected = compareIsSelected ? compareIsSelected(value, optionValue) : value === optionValue;

		return (
			<MenuItem
				columnGap={2}
				display="flex"
				justifyContent="space-between"
				onClick={() => onChange(optionValue)}
				ref={ref}
				_focus={{
					bg: 'secondary.bgAlpha',
				}}
				_notLast={{
					marginBottom: '1px',
				}}
				_hover={{
					bg: 'secondary.bgAlpha',
				}}
				_selected={{
					bg: 'primary.bgAlpha',
				}}
				{...(isSelected && { 'data-selected': true })}
				{...rest}
			>
				{children ?? (valueToString ? valueToString(optionValue) : optionValue)}
				{isSelected && checkIcon}
			</MenuItem>
		);
	}
);

DropdownOption.displayName = 'DropdownOption';
